import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ResponseSAS} from '../../Interfaces/ResponseSAS';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogInService {

  constructor(private http: HttpClient) { }

  GetToken(
    //CompanyID: Number,
    SalesChannelCode: String,
    SalesChannelType: String,
    UserName: String
  ):Observable<ResponseSAS>
   {
    return this.http.post<ResponseSAS>(
      environment.urlSAS,
      {
        "screenIdentification": environment[localStorage.ambiente].getToken,  
        "Parameters": [  
        {"parametername":"CompanyID", "parametervalue":0},        
        {"parametername":"SalesChannelCode", "parametervalue":SalesChannelType},
        {"parametername":"SalesChannelType", "parametervalue":SalesChannelCode},
        {"parametername":"UserName", "parametervalue":UserName}
      ]  
      }
    );
  };

  GetSessionID(
    //CompanyID: Number,
    Token: String
  ): Observable<ResponseSAS> {
    return this.http.post<ResponseSAS>(
      environment.urlSAS,
      {
        "screenIdentification": environment[localStorage.ambiente].getSessionID,
        "userToken": Token
      }
    );
  };
}
